import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import { useForm, Controller } from "react-hook-form";

import { ToastContainer, toast } from "react-toastify";

import { Modal } from "react-bootstrap";

import ReactDatePicker from "react-datepicker";

import getMandatoryEnv from "../../../../../sites-common/utils/getMandatoryEnv";

import getFormattedDate from "../../../../../sites-common/utils/FormatDate";

import { nameReg, emailReg, phoneReg } from "../../../assets/data/config";

import {
  appointmentTime,
  specialityData,
} from "../../../assets/data/constantBookappointmentData";

function MyVerticallyCenteredModal(dataEvent) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    reset,
  } = useForm();
  const [, setArrivalDate] = useState("");
  const arrivalDateChange = (e) => {
    setArrivalDate(e);
  };
  const { kmcFormConfig } = getMandatoryEnv(["kmcFormConfig"]);
  const onSubmit = (data) => {
    const dataObj = {};

    const todayVal = getFormattedDate(new Date(), "Date-Time");

    const appointVal = getFormattedDate(new Date(data.arrival));

    dataObj.submitteddate = todayVal;
    dataObj.name = data.name;
    dataObj.emailid = data.email;
    dataObj.phoneno = data.phoneno;
    dataObj.date = appointVal;
    dataObj.time = data.time;
    dataObj.speciality = data.speciality;
    dataObj.comments = data.comments;
    dataObj.projectname = "KMC";

    axios
      .post(`${kmcFormConfig.formUrl}/api/kmc/appointment`, dataObj)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Form submitted successfully");
          reset();
        } else {
          toast.error("something went wrong");
        }
      });
  };

  return (
    <Modal
      {...dataEvent}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kmc_modal"
    >
      <Modal.Header closeButton className="kmc-modal-header">
        <Modal.Title id="contained-modal-title-vcenter" />
        <h3 className="form-head">Book an appointment</h3>
      </Modal.Header>
      <Modal.Body>
        <div id="contact">
          <section className="py-5 contactus">
            <div className="container contact-info">
              <form onSubmit={handleSubmit(onSubmit)} className="kmc-form">
                <div className="row mb-2">
                  <div className="col-md-12">
                    <label htmlFor="name">
                      Name <span className="label-color">*</span>
                      <input
                        type="text"
                        {...register("name", {
                          required: "This field is required",
                          pattern: {
                            value: nameReg,
                            message: "Please enter a valid name",
                          },
                        })}
                        name="name"
                        className="form-control shadow-none rounded-0"
                      />
                    </label>
                    {errors.name && (
                      <span className="form-error">{errors.name.message}</span>
                    )}

                    <div className="invalid-feedback">Please enter name.</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="name">
                      Email <span className="label-color">*</span>
                      <input
                        type="text"
                        {...register("email", {
                          required: "This field is required",
                          pattern: {
                            value: emailReg,
                            message: "Please enter a valid email",
                          },
                        })}
                        className="form-control shadow-none rounded-0"
                        name="email"
                      />
                    </label>
                    {errors.email && (
                      <span className="form-error">{errors.email.message}</span>
                    )}
                    <div className="invalid-feedback">
                      Please enter email id
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-12">
                    <label htmlFor="name">
                      Phone no <span className="label-color">*</span>
                      <input
                        type="number"
                        {...register("phoneno", {
                          required: "This filed is required",
                          pattern: {
                            value: phoneReg,
                            message: "Please enter a valid Mobile Number",
                          },
                        })}
                        className="form-control shadow-none rounded-0"
                        id="phoneno"
                      />
                    </label>

                    {errors.phoneno && (
                      <span className="form-error">
                        {errors.phoneno.message}
                      </span>
                    )}
                    <div className="invalid-feedback">Please enter phone.</div>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-12">
                    <div>
                      Appointment date <span className="label-color">*</span>
                    </div>
                    <Controller
                      control={control}
                      name="arrival"
                      defaultValue={null}
                      render={(props) => {
                        return (
                          <ReactDatePicker
                            {...props.field}
                            onChange={(date) => {
                              arrivalDateChange(date);
                              props.field.onChange(
                                date,
                                setValue("Departure", "")
                              );
                            }}
                            selected={props.field.value}
                            className="form-control shadow-none rounded-0"
                            minDate={new Date()}
                          />
                        );
                      }}
                      rules={{ required: true }}
                    />
                    {errors.arrival && (
                      <span className="form-error">This filed is required</span>
                    )}
                    <div className="invalid-feedback">Please enter date</div>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-12">
                    <label htmlFor="name">
                      Appointment time <span className="label-color">*</span>
                      <select
                        {...register("time")}
                        className="form-control shadow-none rounded-0"
                        id="time"
                        name="time"
                      >
                        {appointmentTime.map((items) => {
                          return <option key={items.id}>{items.time}</option>;
                        })}
                      </select>
                    </label>

                    <div className="invalid-feedback">Please enter Time.</div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-12">
                    <label htmlFor="name">
                      Speciality <span className="label-color">*</span>
                      <select
                        {...register("speciality")}
                        className="form-control shadow-none rounded-0"
                        id="speciality"
                        name="speciality"
                      >
                        {specialityData.map((items) => {
                          return (
                            <option key={items.id}>{items.speciality}</option>
                          );
                        })}
                      </select>
                    </label>

                    <div className="invalid-feedback">
                      Please enter speciality.
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-12">
                    <label htmlFor="name">
                      Comment
                      <textarea
                        {...register("comments")}
                        name="comments"
                        className="form-control shadow-none rounded-0 commentsbox"
                      />
                    </label>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-8">
                    <input
                      type="submit"
                      value="Book Now"
                      className="btn btn-primary btn-rounded px-5"
                    />
                  </div>
                </div>
              </form>
            </div>
          </section>
          <div>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              newestOnTop={false}
              hideProgressBar
              closeOnClick
              rtl={false}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function Bookappointment() {
  const [modalShow, setModalShow] = React.useState(false);
  const loadWidget = () => {
    document.querySelector("#prime")?.click();
  };
  return (
    <>
      <button
        type="button"
        className="banner-button"
        onKeyDown={() => loadWidget()}
        onClick={() => loadWidget()}
      >
        {" "}
        Book an appointment
      </button>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}
MyVerticallyCenteredModal.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default Bookappointment;
